export default "\n.design-buttons-wrapper[data-v-0dca3159] {\n    gap: .25em;\n    margin-left: .25em;\n}\n\n"